/**
 * Fetch Gifts UseCase
 *
 * Loads the locally cached gift catalogue.
 * Flutter source: send_gift_bottom_sheet.dart:_getLocalGifts
 */
import type { GiftEntity } from '@/domain/entities/gift/giftEntity';
import type { GiftService } from '@/domain/services/gift/giftService';

export class FetchGiftsUseCase {
  constructor(private readonly giftService: GiftService) {}

  async execute(): Promise<GiftEntity[]> {
    return this.giftService.getLocalGifts();
  }
}
